// ============================================================
// 卡牌系統 — 卡牌目錄
// ============================================================
// 每張卡對接引擎既有的 spell 效果（透過 element = ELEM id）。
// 疊加型 → spell.ts 之後改吃「疊加張數 stackCount」取代 powerLevel；
// 效果型 → 固定效果值（取消等級）。
// ============================================================

import type { CardDef, CardId } from './CardTypes.ts';

// 元素 id（= constants.ts ELEM 索引）
const FIRE = 1,
  WATER = 2,
  WIND = 3,
  LIGHT = 4,
  LIGHTNING = 5,
  WIND_FRIENDLY = 6,
  WIND_HOSTILE = 7,
  GROW = 8,
  RAIN = 9,
  ROCKFALL = 10;

export const CARDS: Record<CardId, CardDef> = {
  // —— 類型一：可疊加增強牌（copyLimit 4）——
  fireball: { id: 'fireball', name: '火球', category: 'stackable', element: FIRE, copyLimit: 4, text: '範圍傷害 + 點燃草地；疊加放大傷害' },
  lightning: { id: 'lightning', name: '閃電', category: 'stackable', element: LIGHTNING, copyLimit: 4, text: '範圍傷害 + 對積水目標加成；疊加放大' },
  heal: { id: 'heal', name: '補血', category: 'stackable', element: WATER, copyLimit: 4, text: '範圍治癒；疊加放大治癒量' },
  buffAtk: { id: 'buffAtk', name: '加攻', category: 'stackable', element: LIGHT, copyLimit: 4, text: '範圍我方攻擊提升；疊加放大' },
  shield: { id: 'shield', name: '護盾', category: 'stackable', element: WIND, copyLimit: 4, text: '範圍物理+法術減免；疊加放大' },

  // —— 類型二：單純效果牌（無等級，copyLimit 2）——
  rain: { id: 'rain', name: '降雨', category: 'effect', element: RAIN, copyLimit: 2, text: '鋪積水 / 淹水 / 草地→沼澤' },
  grow: { id: 'grow', name: '長草', category: 'effect', element: GROW, copyLimit: 2, text: '鋪草 / 纏根 / 降防' },
  rockfall: { id: 'rockfall', name: '落石', category: 'effect', element: ROCKFALL, copyLimit: 2, text: '砸傷 / 生成不可通行石牆' },
  whirlFoe: { id: 'whirlFoe', name: '旋風-敵', category: 'effect', element: WIND_HOSTILE, copyLimit: 2, text: '拉動敵方位移 + 減攻' },
  whirlAlly: { id: 'whirlAlly', name: '旋風-友', category: 'effect', element: WIND_FRIENDLY, copyLimit: 2, text: '拉動我方位移 + 補血' },

  // —— 類型三：濾牌牌（copyLimit 3）——
  draw: { id: 'draw', name: '抽牌', category: 'filter', copyLimit: 3, filterKind: 'draw', filterAmount: 2, text: '抽 2 張（不佔 tick）' },
  tutor: { id: 'tutor', name: '搜牌', category: 'filter', copyLimit: 3, filterKind: 'tutor', filterAmount: 1, text: '從牌庫找指定 1 張上手' },
  cycle: { id: 'cycle', name: '調度', category: 'filter', copyLimit: 3, filterKind: 'cycle', filterAmount: 2, text: '棄至多 2 張、補抽等量' },
};

export function getCard(id: CardId): CardDef | undefined {
  return CARDS[id];
}
